import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const EditTariffModal = ({ open, handleClose, handleUpdate, tariff }) => {
  const [tariffData, setTariffData] = useState({
    name: '',
    price_per_hour: '',
    price_per_kwh: '',
    connection_fee: '',
    min_charge: '',
    start_at: '',
    end_at: '',
    is_active: true,
  });

  useEffect(() => {
    if (tariff) {
      setTariffData({
        name: tariff.name || '',
        price_per_hour: tariff.price_per_hour || '',
        price_per_kwh: tariff.price_per_kwh || '',
        connection_fee: tariff.connection_fee || '',
        min_charge: tariff.min_charge || '',
        start_at: tariff.start_at ? new Date(tariff.start_at).toISOString().slice(0, 16) : '',
        end_at: tariff.end_at ? new Date(tariff.end_at).toISOString().slice(0, 16) : '',
        is_active: tariff.is_active,
      });
    }
  }, [tariff]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTariffData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const buildUpdatePayload = () => {
    const numericFields = ['price_per_hour', 'price_per_kwh', 'connection_fee', 'min_charge'];
    const payload = { ...tariffData };

    numericFields.forEach((field) => {
      const value = payload[field];
      payload[field] = value === '' || value === null || Number.isNaN(Number(value))
        ? 0
        : parseFloat(value);
    });

    if (!payload.start_at) {
      delete payload.start_at;
    } else {
      payload.start_at = new Date(payload.start_at).toISOString();
    }

    if (!payload.end_at) {
      delete payload.end_at;
    } else {
      payload.end_at = new Date(payload.end_at).toISOString();
    }

    payload.is_active = Boolean(payload.is_active);
    return payload;
  };

  const handleSubmit = () => {
    handleUpdate(tariff.tariff_id, buildUpdatePayload());
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="edit-tariff-modal-title"
    >
      <Box sx={style}>
        <Typography id="edit-tariff-modal-title" variant="h6" component="h2">
          Editar Tarifa
        </Typography>
        <TextField
          margin="normal"
          required
          fullWidth
          id="name"
          label="Nombre de la Tarifa"
          name="name"
          autoFocus
          value={tariffData.name}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="price_per_kwh"
          label="Precio por kWh"
          type="number"
          id="price_per_kwh"
          value={tariffData.price_per_kwh}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="price_per_hour"
          label="Precio por Hora"
          type="number"
          id="price_per_hour"
          value={tariffData.price_per_hour}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          name="connection_fee"
          label="Costo de Conexión (opcional)"
          type="number"
          id="connection_fee"
          value={tariffData.connection_fee}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          name="min_charge"
          label="Cargo Mínimo (opcional)"
          type="number"
          id="min_charge"
          value={tariffData.min_charge}
          onChange={handleChange}
        />
        <TextField
          margin="normal"
          fullWidth
          name="start_at"
          label="Fecha de Inicio"
          type="datetime-local"
          id="start_at"
          value={tariffData.start_at}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          margin="normal"
          fullWidth
          name="end_at"
          label="Fecha de Fin"
          type="datetime-local"
          id="end_at"
          value={tariffData.end_at}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={handleSubmit}
        >
          Actualizar
        </Button>
      </Box>
    </Modal>
  );
};

export default EditTariffModal;
